import React from 'react';

import './style.scss';
import { Link } from "react-router-dom";
import Btn from "../../Btn";

export const YourSupport = () => {
    return (
        <div className = 'wt wt-your-support'>
            <a className = 'wt__container wt-your-support__container'
            href='https://itseems.tellme.com.ua/'
               target='_blank'
            >
                <h4 className = 'wt__title wt-your-support__title'>Ваша підтримка поруч</h4>
                <p className = 'wt__dc wt-your-support__desc'>
                    Зверніться за безкоштовною психологічною допомогою до наших спеціалістів.
                </p>
                <div className = 'wt-your-support__btn'>
                    <Btn
                        full
                        theme = 'main'
                        title = 'Звернутися за підтримкою'
                    />
                </div>
            </a>
        </div>
    );

};
